import { Injectable } from "@angular/core";
import { NavigationService } from "./navigation.service";
import { BaseNavigationStrategyService } from "./base-navigation-strategy.service";
import { FocusFieldStrategy } from "../directives/navigation-section.directive";

@Injectable({
    providedIn: 'root'
})
export class VerticalNavigationStrategyService extends BaseNavigationStrategyService {

    handleKeyPress(event: KeyboardEvent): void {
        if (NavigationService.UP_KEY.includes(event.keyCode)) { //su
            if (this.isFirstOrUniqueFieldOfActiveSection()) {
                this.moveToPreviousSection(FocusFieldStrategy.Last);
            } else {
                this.moveToPreviousField(event);
            }
        } else if (NavigationService.DOWN_KEY.includes(event.keyCode)) { //giu
            if (this.isLastOrUniqueFieldOfActiveSection()) {
                this.moveToNextSection(FocusFieldStrategy.First);
            } else {
                this.moveToNextField(event);
            }
        }
    }
}
